export enum UserRoles {
  SuperAdmin = 0,
  Reviewer = 1,
  PKReviewer = 2,
  CsiUser = 3,
  ProductUser = 4,
  CompanyAdmin = 5,
  CompanySecondaryAdmin = 6,
  Pba = 7,
}
